import { CommonProps } from '@antv/g6-react-node/dist/ReactNode/Group';
import { CommonShapeProps } from '@antv/g6-react-node/dist/ReactNode/Shape/common';
import { ImageStyle } from '@antv/g6-react-node/dist/ReactNode/Shape/Image';
import { RectStyle } from '@antv/g6-react-node/dist/ReactNode/Shape/Rect';
import { TextStyle } from '@antv/g6-react-node/dist/ReactNode/Shape/Text';

import { Group, Image, Rect, Text } from '@antv/g6-react-node';
import React, { PropsWithChildren } from 'react';

export type NodeGroupProps = PropsWithChildren<CommonProps> & {
	style?: CommonShapeProps & {
		position?: string
	};
};

export const NodeGroup: React.FC<NodeGroupProps> = (props) => <Group { ...props } />;

export type NodeRectProps = PropsWithChildren<CommonProps & {
	keyshape?: boolean;
	style: RectStyle & {
		position?: string
	}
}>;

export const NodeRect: React.FC<NodeRectProps> = (props) =>
	<Rect { ...props } />;

export type NodeTextProps = PropsWithChildren<CommonProps & {
	style: Omit<TextStyle, 'fontSize'> & {
		fontSize?: number;
	}
}>;

export const NodeText: React.FC<NodeTextProps> = (props) =>
	<Text
		{ ...props }
		style={ props.style as TextStyle } />;

export type NodeImageProps = CommonProps & {
	style: ImageStyle & {
		filter?: string;
	}
};

export const NodeImage: React.FC<NodeImageProps> = (props) =>
	<Image { ...props } />;
